import { makeStyles } from 'tss-react/mui';

import { isLightTheme } from 'uiKit/Theme/themeUtils';

const name = 'TopBanner';

export const useTopBannerStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minHeight: 40,
    backgroundColor: isLightTheme(theme) ? theme.palette.grey[800] : '#585E6B',
    position: 'fixed',
    top: 0,
    zIndex: 4,
    padding: theme.spacing(3, 7, 4, 3),

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2.5, 2.5),
    },
  },
  text: {
    color: theme.palette.common.white,
    textAlign: 'left',

    '& > span > a': {
      color: theme.palette.common.white,
      textDecoration: 'underline',

      '&:hover': {
        cursor: 'pointer',
      },
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
}));
